module.exports = __webpack_public_path__ + "img/cloud.5a8d0d23.svg";